import React from "react";
import I18n from "../../../i18n/";
import { CounselingGeneric } from "./index";
import ReportAction from "../../../actions/ReportAction";
import { CounselingSupportGraph } from "../../../constants/supportGraph";
import { TargetValueType } from "../CompareValuePanel";
import ReportUtil from "../../../util/report";

export default (props)=>(
	<CounselingGeneric 
		typeKey={CounselingSupportGraph.Platform}
		subHeader={I18n.t("platform")}
		fetchMain={ReportAction.fetchCounPlatform}
		getAutoSelectItem={ReportUtil.pickAvailableNumberValueKey}
	/>
);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/Counseling/CounselingPlatform.js